import AxiosInterceptor from "api/interceptor";

const media = new AxiosInterceptor();

export default {
  uploadMulti(files, type) {
    let formData = new FormData();
        
    for (let i = 0; i < files.length; i++) {
      formData.append("file[]", files[i]);
    }
        
    if (type) {
      formData.append("type", type);
    }

    return media.post("/media/multi-upload", formData);
  },
  upload(file, type) {
    let formData = new FormData();
    formData.append("file", file);

    if (type) {
      formData.append("type", type);
    }

    return media.post("/media/upload", formData);
  }
};
